const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnSitio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1213.8 533",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M656,193.2h61.2v15.4H673.4v31h43.2v15.2H673.4v32.4h43.8v15.4H656Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.4,222.2h14.5v12.4c3.9-8.3,12.9-14.9,27.2-14.8,25.8.3,32.6,18.9,32.6,35.6v47.2H792.1V259c0-14.5-5.6-24.9-21.3-24.7s-22,9.6-22,23.5v44.8H733.4Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.6,243.2c0-6.2-3.8-11-11.7-10.8s-11.6,5-11.5,10.3,6.1,9.3,14.6,11.7c12.3,3.4,25.8,6.9,26.2,24.2.3,15.7-12.7,26.4-28.7,26.4-12.7,0-28.5-7.3-29.3-25.6h15.3c.6,9.7,8.4,13,14.2,13,7.4,0,13.1-5.2,13.1-12s-6.2-10.6-20.5-15.4c-11.3-3.4-20.1-8.7-20.3-20.8,0-15.2,12.4-24.4,27.1-24.4,11.1,0,25.6,5.5,26.7,23.4Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.6,193.2h15.3v16.2H935.6Zm0,29h15.3v80.4H935.6Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.3,234.1H960.8V222.2h14.5v-29h15.4v29h15.5v11.9H990.7v68.5H975.3Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.3,193.2h15.4v16.2h-15.4Zm0,29h15.4v80.4h-15.4Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7,262.2c0-21.4,15.8-42.4,42.9-42.4s42.9,21,42.9,42.6-15.9,42.4-42.9,42.4-42.9-20.8-42.9-42.4Zm15.4.3c0,16,12.1,28,27.5,28s27.5-12,27.5-28.1-12.1-28.1-27.5-28.1-27.5,12-27.5,28.1Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.4,347.4c0-95.4-77.4-172.7-172.8-172.7A172.8,172.8,0,1,0,564.4,347.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.5,345c0-95.4-77.4-172.7-172.8-172.7S216.9,249.6,216.9,345s77.4,172.8,172.8,172.8S562.5,440.4,562.5,345Z",
    style: {
      fill: "#afafaf",
      opacity: 0.024390242993833
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.5,342.6c0-95.4-77.3-172.8-172.7-172.8A172.8,172.8,0,1,0,560.5,342.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.048780486942867
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.6,340.2c0-95.4-77.4-172.8-172.8-172.8S213,244.8,213,340.2s77.4,172.7,172.8,172.7S558.6,435.6,558.6,340.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.073170730891901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.6,337.7A172.8,172.8,0,1,0,383.9,510.5,172.7,172.7,0,0,0,556.6,337.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.097560974840936
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.7,335.3c0-95.4-77.4-172.7-172.8-172.7A172.7,172.7,0,0,0,209.2,335.3c0,95.4,77.3,172.8,172.7,172.8S554.7,430.7,554.7,335.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.12195121878997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.7,332.9c0-95.4-77.3-172.8-172.7-172.8S207.2,237.5,207.2,332.9,284.6,505.7,380,505.7,552.7,428.3,552.7,332.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.146341462739004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.8,330.5c0-95.4-77.3-172.8-172.7-172.8A172.8,172.8,0,1,0,550.8,330.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.170731706688038
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.9,328c0-95.4-77.4-172.7-172.8-172.7S203.3,232.6,203.3,328a172.8,172.8,0,1,0,345.6,0Z",
    style: {
      fill: "#afafaf",
      opacity: 0.195121950637073
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.9,325.6A172.8,172.8,0,1,0,374.2,498.4C469.6,498.4,546.9,421,546.9,325.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.219512194586107
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545,323.2c0-95.4-77.4-172.8-172.8-172.8S199.5,227.8,199.5,323.2,276.8,496,372.2,496,545,418.6,545,323.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.243902438535141
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543,320.8C543,225.4,465.7,148,370.3,148S197.5,225.4,197.5,320.8s77.4,172.7,172.8,172.7A172.7,172.7,0,0,0,543,320.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.268292682484175
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.1,318.3c0-95.4-77.4-172.7-172.8-172.7A172.8,172.8,0,1,0,541.1,318.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.29268292643321
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.1,315.9A172.7,172.7,0,0,0,366.4,143.2c-95.4,0-172.8,77.3-172.8,172.7S271,488.7,366.4,488.7,539.1,411.3,539.1,315.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.317073170382244
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.2,313.5c0-95.4-77.3-172.8-172.7-172.8a172.8,172.8,0,0,0,0,345.6C459.9,486.3,537.2,408.9,537.2,313.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.341463414331278
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.3,311.1c0-95.4-77.4-172.8-172.8-172.8S189.7,215.7,189.7,311.1s77.4,172.7,172.8,172.7S535.3,406.5,535.3,311.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.365853658280313
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.3,308.6A172.8,172.8,0,1,0,360.6,481.4,172.7,172.7,0,0,0,533.3,308.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.390243902229347
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.4,306.2c0-95.4-77.4-172.7-172.8-172.7A172.7,172.7,0,0,0,185.9,306.2c0,95.4,77.3,172.8,172.7,172.8S531.4,401.6,531.4,306.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.414634146178381
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.4,303.8c0-95.4-77.3-172.8-172.7-172.8S183.9,208.4,183.9,303.8s77.4,172.8,172.8,172.8S529.4,399.2,529.4,303.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.439024390127415
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.5,301.4c0-95.4-77.4-172.8-172.8-172.8S182,206,182,301.4A172.7,172.7,0,0,0,354.7,474.1C450.1,474.1,527.5,396.8,527.5,301.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.46341463407645
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.6,298.9c0-95.4-77.4-172.7-172.8-172.7S180,203.5,180,298.9a172.8,172.8,0,0,0,345.6,0Z",
    style: {
      fill: "#afafaf",
      opacity: 0.487804878025484
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.6,296.5A172.8,172.8,0,1,0,350.9,469.3C446.3,469.3,523.6,391.9,523.6,296.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.512195121974518
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.7,294.1c0-95.4-77.4-172.8-172.8-172.8S176.1,198.7,176.1,294.1s77.4,172.8,172.8,172.8S521.7,389.5,521.7,294.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.536585365923552
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.7,291.7c0-95.4-77.3-172.8-172.7-172.8A172.8,172.8,0,1,0,519.7,291.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.560975609872587
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.8,289.2c0-95.4-77.4-172.7-172.8-172.7A172.8,172.8,0,1,0,517.8,289.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.585365853821621
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.8,286.8A172.7,172.7,0,0,0,343.1,114.1c-95.4,0-172.8,77.3-172.8,172.7s77.4,172.8,172.8,172.8S515.8,382.2,515.8,286.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.609756097770655
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.9,284.4c0-95.4-77.3-172.8-172.7-172.8a172.8,172.8,0,0,0,0,345.6C436.6,457.2,513.9,379.8,513.9,284.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.634146341719689
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,282c0-95.4-77.4-172.8-172.8-172.8S166.4,186.6,166.4,282s77.4,172.7,172.8,172.7S512,377.4,512,282Z",
    style: {
      fill: "#afafaf",
      opacity: 0.658536585668724
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510,279.5A172.8,172.8,0,1,0,337.3,452.3,172.7,172.7,0,0,0,510,279.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.682926829617758
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.1,277.1c0-95.4-77.4-172.7-172.8-172.7A172.7,172.7,0,0,0,162.6,277.1c0,95.4,77.3,172.8,172.7,172.8S508.1,372.5,508.1,277.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.707317073566792
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.1,274.7c0-95.4-77.3-172.8-172.7-172.8S160.6,179.3,160.6,274.7,238,447.5,333.4,447.5,506.1,370.1,506.1,274.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.731707317515826
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.2,272.3c0-95.4-77.4-172.8-172.8-172.8S158.7,176.9,158.7,272.3A172.7,172.7,0,0,0,331.4,445C426.8,445,504.2,367.7,504.2,272.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.75609756146486
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.2,269.8A172.7,172.7,0,0,0,329.5,97.1c-95.4,0-172.8,77.3-172.8,172.7a172.8,172.8,0,1,0,345.5,0Z",
    style: {
      fill: "#afafaf",
      opacity: 0.780487805413895
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.3,267.4A172.8,172.8,0,1,0,327.6,440.2C423,440.2,500.3,362.8,500.3,267.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.804878049362929
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.4,265c0-95.4-77.4-172.8-172.8-172.8S152.8,169.6,152.8,265s77.4,172.8,172.8,172.8S498.4,360.4,498.4,265Z",
    style: {
      fill: "#afafaf",
      opacity: 0.829268293311963
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.4,262.6c0-95.4-77.3-172.8-172.7-172.8A172.8,172.8,0,1,0,496.4,262.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.853658537260997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.5,260.1c0-95.4-77.4-172.7-172.8-172.7A172.8,172.8,0,1,0,494.5,260.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.878048781210032
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.5,257.7A172.7,172.7,0,0,0,319.8,85C224.4,85,147,162.3,147,257.7s77.4,172.8,172.8,172.8S492.5,353.1,492.5,257.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.902439025159066
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.6,255.3c0-95.4-77.4-172.8-172.8-172.8S145.1,159.9,145.1,255.3s77.3,172.8,172.7,172.8S490.6,350.7,490.6,255.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.9268292691081
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.7,252.9c0-95.4-77.4-172.8-172.8-172.8S143.1,157.5,143.1,252.9s77.4,172.7,172.8,172.7S488.7,348.3,488.7,252.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.951219513057134
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.7,250.4A172.8,172.8,0,1,0,314,423.2,172.7,172.7,0,0,0,486.7,250.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.975609757006168
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.8,248c0-95.4-77.4-172.7-172.8-172.7S139.2,152.6,139.2,248,216.6,420.8,312,420.8,484.8,343.4,484.8,248Z",
    style: {
      fill: "#afafaf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.8,146a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,178.8,146Z",
    style: {
      fill: "#afafaf",
      opacity: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.2,145.1a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,178.2,145.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.024390242993833
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5,144.3a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,177.5,144.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.048780486942867
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.8,143.4A59.6,59.6,0,1,0,117.3,203,59.5,59.5,0,0,0,176.8,143.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.073170730891901
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.2,142.6a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,176.2,142.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.097560974840936
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5,141.8a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,175.5,141.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.12195121878997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.8,140.9a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,174.8,140.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.146341462739004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1,140.1a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,174.1,140.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.170731706688038
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,139.3a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,173.5,139.3Z",
    style: {
      fill: "#afafaf",
      opacity: 0.195121950637073
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.8,138.4A59.6,59.6,0,1,0,113.3,198,59.5,59.5,0,0,0,172.8,138.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.219512194586107
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.1,137.6a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,172.1,137.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.243902438535141
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.5,136.8a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,171.5,136.8Z",
    style: {
      fill: "#afafaf",
      opacity: 0.268292682484175
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.8,135.9a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,170.8,135.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.29268292643321
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.1,135.1a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,170.1,135.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.317073170382244
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.5,134.2a59.6,59.6,0,1,0-59.6,59.6A59.6,59.6,0,0,0,169.5,134.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.341463414331278
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.8,133.4A59.6,59.6,0,1,0,109.2,193,59.5,59.5,0,0,0,168.8,133.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.365853658280313
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.1,132.6a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,168.1,132.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.390243902229347
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.5,131.7a59.6,59.6,0,1,0-59.6,59.6A59.6,59.6,0,0,0,167.5,131.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.414634146178381
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.8,130.9a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,166.8,130.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.439024390127415
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.1,130.1a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,166.1,130.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.46341463407645
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.4,129.2a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,165.4,129.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.487804878025484
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.8,128.4A59.6,59.6,0,1,0,105.2,188,59.6,59.6,0,0,0,164.8,128.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.512195121974518
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,127.6a59.6,59.6,0,1,0-59.5,59.5A59.6,59.6,0,0,0,164.1,127.6Z",
    style: {
      fill: "#afafaf",
      opacity: 0.536585365923552
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4,126.7a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,163.4,126.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.560975609872587
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.8,125.9a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,162.8,125.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.585365853821621
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.1,125.1a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,162.1,125.1Z",
    style: {
      fill: "#afafaf",
      opacity: 0.609756097770655
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.4,124.2a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,161.4,124.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.634146341719689
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.8,123.4a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,160.8,123.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.658536585668724
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.1,122.5a59.6,59.6,0,1,0-59.6,59.6A59.6,59.6,0,0,0,160.1,122.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.682926829617758
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.4,121.7a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,159.4,121.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.707317073566792
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.8,120.9a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,158.8,120.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.731707317515826
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,120a59.6,59.6,0,1,0-59.6,59.6A59.6,59.6,0,0,0,158.1,120Z",
    style: {
      fill: "#afafaf",
      opacity: 0.75609756146486
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.4,119.2a59.6,59.6,0,1,0-59.5,59.6A59.5,59.5,0,0,0,157.4,119.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.780487805413895
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.7,118.4a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,156.7,118.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.804878049362929
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.1,117.5a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,156.1,117.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.829268293311963
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,116.7a59.6,59.6,0,1,0-59.5,59.5A59.6,59.6,0,0,0,155.4,116.7Z",
    style: {
      fill: "#afafaf",
      opacity: 0.853658537260997
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.7,115.9a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,154.7,115.9Z",
    style: {
      fill: "#afafaf",
      opacity: 0.878048781210032
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.1,115a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,154.1,115Z",
    style: {
      fill: "#afafaf",
      opacity: 0.902439025159066
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.4,114.2a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,153.4,114.2Z",
    style: {
      fill: "#afafaf",
      opacity: 0.9268292691081
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.7,113.4a59.6,59.6,0,1,0-59.5,59.5A59.5,59.5,0,0,0,152.7,113.4Z",
    style: {
      fill: "#afafaf",
      opacity: 0.951219513057134
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.1,112.5a59.6,59.6,0,1,0-59.6,59.6A59.5,59.5,0,0,0,152.1,112.5Z",
    style: {
      fill: "#afafaf",
      opacity: 0.975609757006168
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.4,111.7a59.6,59.6,0,1,0-59.6,59.5A59.6,59.6,0,0,0,151.4,111.7Z",
    style: {
      fill: "#afafaf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.8,248c0-95.4-77.4-172.7-172.8-172.7S139.2,152.6,139.2,248,216.6,420.8,312,420.8,484.8,343.4,484.8,248Z",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.3,
    cy: 110.7,
    rx: 60.6,
    ry: 61.2,
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4,146.4H59a2.9,2.9,0,0,1-3-2.9V83.6a2.9,2.9,0,0,1,2.6-2.9L97.9,75a3,3,0,0,1,2.4.7,2.7,2.7,0,0,1,1,2.2v65.6A2.9,2.9,0,0,1,98.4,146.4Zm-36.5-5.9H95.4V81.4L61.9,86.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5,146.4H72.7a3,3,0,0,1-3-3V129.6a2.9,2.9,0,0,1,3-3H84.5a2.9,2.9,0,0,1,3,3v13.8A3,3,0,0,1,84.5,146.4Zm-8.9-6h6v-7.9h-6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.2,
    y: 113.4,
    width: 6.9,
    height: 6.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.2,
    y: 97.1,
    width: 6.9,
    height: 6.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.7,146.4H98.4a2.9,2.9,0,0,1-3-2.9V100.9a3,3,0,0,1,1.1-2.3A3.2,3.2,0,0,1,99,98l23.3,4.9a3,3,0,0,1,2.4,2.9v37.7A3,3,0,0,1,121.7,146.4Zm-20.4-5.9h17.4V108.2l-17.4-3.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,146.4a3.1,3.1,0,0,1-3-3v-8.6a3,3,0,0,1,3-3,2.9,2.9,0,0,1,3,3v8.6A3,3,0,0,1,110,146.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.2,276H196a7.8,7.8,0,0,1-7.9-7.8v-2.8a7.8,7.8,0,0,1,7.9-7.8h8.2a7.8,7.8,0,0,1,7.8,7.8v2.7h0A7.8,7.8,0,0,1,204.2,276Zm0-11H196a.5.5,0,0,0-.5.4v2.7a.5.5,0,0,0,.5.5h8.2a.5.5,0,0,0,.4-.5v-2.7A.4.4,0,0,0,204.2,265Zm4.1,3.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.5,246.5H217.7a4.7,4.7,0,0,0-4.6,4.7v48.4h81.1V251.2A4.8,4.8,0,0,0,289.5,246.5Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.5,303.3a3.7,3.7,0,0,1-3.7-3.7V278.8h-212a3.8,3.8,0,0,1,0-7.5H393.5a3.8,3.8,0,0,1,3.8,3.7v24.6A3.7,3.7,0,0,1,393.5,303.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.3,190.8a24.3,24.3,0,1,1,24.3-24.3A24.3,24.3,0,0,1,238.3,190.8Zm0-41.1a16.9,16.9,0,1,0,16.8,16.8A16.8,16.8,0,0,0,238.3,149.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.1,262.9h-.5a3.7,3.7,0,0,1-3.1-4.2l6.1-42.6a18.6,18.6,0,0,1,18.6-18.3h28.2A18.6,18.6,0,0,1,271,216.3v3.9a3.8,3.8,0,0,1-3.7,3.7,3.7,3.7,0,0,1-3.7-3.7v-3.9a11.2,11.2,0,0,0-11.2-11.2H224.2A11.2,11.2,0,0,0,213,216.3v.5l-6.2,42.9A3.8,3.8,0,0,1,203.1,262.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,339.9h-8.2a7.8,7.8,0,0,1-7.9-7.8v-2.8a7.8,7.8,0,0,1,7.9-7.8H325a7.8,7.8,0,0,1,7.8,7.8v2.8h0A7.8,7.8,0,0,1,325,339.9Zm0-11h-8.2a.5.5,0,0,0-.5.4v2.8a.5.5,0,0,0,.5.4H325a.4.4,0,0,0,.4-.4v-2.8A.4.4,0,0,0,325,328.9Zm4.1,3.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.6,323l6.2-45.7c0-8.8,6.7-15.8,14.9-15.8h28.2c8.2,0,14.9,7,14.9,15.8v4.1",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.6,326.8h-.5a3.7,3.7,0,0,1-3.2-4.2l6.2-45.5c.1-10.6,8.4-19.3,18.6-19.3h28.2c10.2,0,18.6,8.8,18.6,19.6v4.1a3.8,3.8,0,1,1-7.5,0v-4.1c0-6.7-5-12.1-11.1-12.1H344.7c-6.2,0-11.2,5.4-11.2,12.1v.5l-6.2,45.7A3.7,3.7,0,0,1,323.6,326.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356,
    cy: 224.8,
    r: 20.6,
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,249.1a24.3,24.3,0,1,1,24.3-24.3A24.3,24.3,0,0,1,356,249.1Zm0-41.1a16.8,16.8,0,1,0,16.9,16.8A16.8,16.8,0,0,0,356,208Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5,262.8h-9.3a9.3,9.3,0,0,1-9.3-9.4V220.7a9.3,9.3,0,0,1,9.3-9.3h56.1a9.3,9.3,0,0,1,9.3,9.3v32.7a9.4,9.4,0,0,1-9.3,9.4h-9.4",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3,265.4h-9.4a2.7,2.7,0,0,1,0-5.3h9.4a6.7,6.7,0,0,0,6.6-6.7V220.7a6.7,6.7,0,0,0-6.6-6.7H247.2a6.7,6.7,0,0,0-6.7,6.7v32.7a6.7,6.7,0,0,0,6.7,6.7h9.4a2.7,2.7,0,0,1,0,5.3h-9.4a12,12,0,0,1-12-12V220.7a12,12,0,0,1,12-12h56.1a12,12,0,0,1,12,12v32.7A12,12,0,0,1,303.3,265.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3,265.8h-9.4a3.1,3.1,0,0,1,0-6.1h9.4a6.3,6.3,0,0,0,6.3-6.3V220.7a6.3,6.3,0,0,0-6.3-6.3H247.2a6.3,6.3,0,0,0-6.3,6.3v32.7a6.3,6.3,0,0,0,6.3,6.3h9.4a3.1,3.1,0,0,1,0,6.1h-9.4a12.5,12.5,0,0,1-12.4-12.4V220.7a12.5,12.5,0,0,1,12.4-12.4h56.1a12.4,12.4,0,0,1,12.3,12.4v32.7A12.4,12.4,0,0,1,303.3,265.8Zm-9.4-5.3a2.3,2.3,0,1,0,0,4.5h9.4a11.6,11.6,0,0,0,11.6-11.6V220.7a11.6,11.6,0,0,0-11.6-11.6H247.2a11.6,11.6,0,0,0-11.6,11.6v32.7A11.6,11.6,0,0,0,247.2,265h9.4a2.2,2.2,0,0,0,2.2-2.2,2.2,2.2,0,0,0-2.2-2.3h-9.4a7,7,0,0,1-7-7.1V220.7a7,7,0,0,1,7-7h56.1a7,7,0,0,1,7,7v32.7a7.1,7.1,0,0,1-7,7.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.6,278H265.5a2.9,2.9,0,0,1-2-.9,3.1,3.1,0,0,1-.7-2.1l3-28a2.7,2.7,0,0,1,2.7-2.4h13.8A2.7,2.7,0,0,1,285,247l3.2,28a2.7,2.7,0,0,1-.6,2.1A2.9,2.9,0,0,1,285.6,278Zm-17.2-5.4h14.2l-2.7-22.7h-9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.7,340.4H296.3a3.8,3.8,0,0,1,0-7.5H438.7a3.8,3.8,0,0,1,0,7.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.7,325.1h-9.4a9.4,9.4,0,0,1-9.3-9.4V283.1a9.4,9.4,0,0,1,9.3-9.4h56.1a9.4,9.4,0,0,1,9.3,9.4v32.6a9.4,9.4,0,0,1-9.3,9.4H420",
    style: {
      fill: "#0b2343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.4,327.8H420a2.7,2.7,0,0,1,0-5.4h9.4a6.7,6.7,0,0,0,6.6-6.7V283a6.7,6.7,0,0,0-6.6-6.6H373.3a6.7,6.7,0,0,0-6.7,6.6v32.7a6.7,6.7,0,0,0,6.7,6.7h9.4a2.7,2.7,0,0,1,0,5.4h-9.4a12.1,12.1,0,0,1-12-12.1V283a12,12,0,0,1,12-12h56.1a12,12,0,0,1,12,12v32.7A12.1,12.1,0,0,1,429.4,327.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.4,328.1H420a2.9,2.9,0,0,1-3-3,3,3,0,0,1,3-3.1h9.4a6.3,6.3,0,0,0,6.3-6.3V283a6.4,6.4,0,0,0-6.3-6.3H373.3A6.3,6.3,0,0,0,367,283v32.7a6.3,6.3,0,0,0,6.3,6.3h9.4a3.1,3.1,0,0,1,3,3.1,3,3,0,0,1-3,3h-9.4a12.4,12.4,0,0,1-12.4-12.4V283a12.4,12.4,0,0,1,12.4-12.3h56.1A12.3,12.3,0,0,1,441.7,283v32.7A12.3,12.3,0,0,1,429.4,328.1Zm-9.4-5.3a2.3,2.3,0,0,0-2.3,2.3,2.4,2.4,0,0,0,2.3,2.3h9.4A11.6,11.6,0,0,0,441,315.7V283a11.6,11.6,0,0,0-11.6-11.6H373.3A11.6,11.6,0,0,0,361.7,283v32.7a11.6,11.6,0,0,0,11.6,11.7h9.4a2.3,2.3,0,0,0,2.2-2.3,2.2,2.2,0,0,0-2.2-2.3h-9.4a7,7,0,0,1-7-7.1V283a7,7,0,0,1,7-7h56.1a7.1,7.1,0,0,1,7,7v32.7a7.1,7.1,0,0,1-7,7.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.7,340.3H391.6a2.5,2.5,0,0,1-2-.9,3.1,3.1,0,0,1-.7-2.1l3-28a2.8,2.8,0,0,1,2.7-2.4h13.8a2.8,2.8,0,0,1,2.7,2.4l3.2,28a2.6,2.6,0,0,1-.6,2.1A2.5,2.5,0,0,1,411.7,340.3ZM394.5,335h14.2L406,312.3h-9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,470.8A222.8,222.8,0,0,1,89.2,248a215.9,215.9,0,0,1,3.1-36.8l2.2.4A220.5,220.5,0,1,0,165.7,83l-1.5-1.7A222.8,222.8,0,1,1,312,470.8Z",
    style: {
      fill: "#0b2343"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnSitio);
export default __webpack_public_path__ + "static/media/en-sitio.9c735b33d76e67d074b17a8057f642f8.svg";
export { ForwardRef as ReactComponent };